import { IMapLngLat, SeparatedLevel, SeparatedLevels } from "~/types/map.interface";
import { type BaseSelectOption } from "~/components/input/BaseSelect.vue";
import { mapSubscriptionModelToLevels, SUBSCRIPTION_MODEL_TAB_LIST } from "~/constants";

const STORE_NAMESPACE = "mapFilter";

interface IMapFilter {
  city: BaseSelectOption;
  activities: BaseSelectOption[];
  tags: BaseSelectOption[];
  search: string;
  searchActivities: string;
  bounds:
    | [
        IMapLngLat, // southwestern corner of the bounds
        IMapLngLat // northeastern corner of the bounds
      ]
    | [];
  subscriptionModel: number;
  availableLevels: SeparatedLevels;
  selectedLevel: SeparatedLevel;
  tabValue: BaseSelectOption;
}

const defaultSubscriptionModelLevel = {
  archived: { id: "", value: "", isAvailable: false, reason: "" },
  default: { id: "", value: "", isAvailable: false, reason: "" }
};

export const useMapFilterStore = defineStore(STORE_NAMESPACE, {
  state(): IMapFilter {
    return {
      city: { id: "", value: "" },
      activities: [],
      tags: [],
      search: "",
      searchActivities: "",
      bounds: [],
      subscriptionModel: 1,
      availableLevels: { archived: [], default: [] },
      selectedLevel: defaultSubscriptionModelLevel,
      tabValue: SUBSCRIPTION_MODEL_TAB_LIST[0], // there should be selected 'Актуальные' tab by default
    };
  },

  getters: {
    availableLevelsGetter({ availableLevels, subscriptionModel }) {
      return availableLevels[mapSubscriptionModelToLevels[subscriptionModel]];
    },
    isLevelSelected({ selectedLevel }) {
      return Boolean(selectedLevel.archived.id && selectedLevel.default.id);
    },
    subscriptionModelTabValue({ subscriptionModel }) {
      return SUBSCRIPTION_MODEL_TAB_LIST[subscriptionModel === 1 ? 0 : 1];
    },
    subscriptionModelTabOptions() {
      return SUBSCRIPTION_MODEL_TAB_LIST;
    },
  },
  actions: {
    injectLocalStorageValues() {
      this.selectedLevel = defaultSubscriptionModelLevel;
      this.city = {
        id: "",
        value: "",
      };
    },
    setSubscriptionModelTabValue(newTabValue: BaseSelectOption) {
      this.tabValue = newTabValue;
      this.subscriptionModel = Number(newTabValue.id);
    },
    setSubscriptionModel(newValue: string) {
      this.subscriptionModel = Number(newValue);
    },
    setMapFilterLevel(newSubscriptionModelLevel: SeparatedLevel) {
      this.selectedLevel = newSubscriptionModelLevel;
    },
    setMapFilterLevels(levels: SeparatedLevels) {
      this.availableLevels = levels;
    },
    setMapFilterCity(value: BaseSelectOption) {
      if (this.city?.id !== value?.id) {
        this.city = value;
      }
    },
    resetMapFilterCity() {
      this.city = { id: "", value: "" };
    },
    setMapFilterActivities(value: BaseSelectOption) {
      if (!value.isAvailable) {
        return;
      }

      const index = this.activities.findIndex((e) => e.id === value.id);
      if (index !== -1) {
        this.activities.splice(index, 1);
      } else {
        this.activities.push(value);
      }
    },
    resetMapFilterActivities() {
      this.activities = [];
    },
    setMapFilterTags(value: BaseSelectOption) {
      const index = this.tags.findIndex((e) => e.id === value.id);
      if (index !== -1) {
        this.tags.splice(index, 1);
      } else {
        this.tags.push(value);
      }
    },
    resetMapFilterTags() {
      this.tags = [];
    },
    resetSearchString() {
      this.search = "";
    },
  },
});
